import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import _ from 'lodash';

const SET_CONFERENCES = 'modules/data/conferences/SET_CONFERENCES';

const initialState = fromJS([]);

const reducer = handleActions({
  [SET_CONFERENCES]: (state, action = {}) => fromJS(action.payload || []),
}, initialState);

export const setConferencesAction = createAction(SET_CONFERENCES, (conferences) => (conferences));

export const getConferencesAsync = (conference) => {
  return async (dispatch, getState, { apiAuth }) => {
    let resp = await apiAuth.get('/conferences/', { params: { conference } });
    resp = _.get(resp, 'data');
    dispatch(setConferencesAction(resp));

    return resp;
  };
};

export default reducer;
